import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import React from 'react';
import DeleteObject from '../../../../common/poppers/DeleteObject';
import DividendRow from './DividendRow';
import ModifyDividend from './ModifyDividend';
import LinkIcon from '@material-ui/icons/Link';
import Matcher from '../../../../common/poppers/MatcherForPayable';
import ManualMatcherForPayable from '../../../../common/poppers/ManualMatcherForPayable';

export const dividendActionItems = [
    {
        dataDialog: "modify-dialog",
        title: "Módosít",
        dialogTitle: "Osztalék módosítása",
        icon: <EditIcon fontSize="small" color="primary" />,
        canShow: (row) => row.privateId,
        actionComponent: (props, close) => <ModifyDividend {...props} close={close} />
    },
    {
        divider: true,
    },
    {
        dataDialog: "transaction-dialog",
        title: "Tranzakció linkel",
        dialogTitle: "Linkel",
        width: "lg",
        icon: <LinkIcon fontSize="small" color="primary" />,
        canShow: (row) => "MATCH_FOUND" === row.state,
        actionComponent: (props, close) => <Matcher {...props} close={close} row={props.row} billtype={props.tabletype} />
    }, 
    {
        dataDialog: "transaction-dialog",
        title: "Manuális tranzakció linkel",
        dialogTitle: "Manuális linkel",
        width: "lg",
        icon: <LinkIcon fontSize="small" color="primary" />,
        canShow: (row) => "NEW" === row.state || "INCOMPLETE" === row.state,
        actionComponent: (props, close) => <ManualMatcherForPayable {...props} close={close} row={props.row} billtype={props.tabletype} />
    },
    {
        divider: true,
    },
    {
        dataDialog: "delete-dialog",
        title: "Törlés",
        dialogTitle: "Osztalék törlése",
        icon: <DeleteIcon fontSize="small" color="primary" />,
        actionComponent: (props, close) => <DeleteObject {...props} close={close} path={'/api/dividend'} comp={<DividendRow {...props} />} />
    }
]